(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-now"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wp-buy-now')) {
    customElements.define(
      'wp-buy-now',
      class extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('button');
          this.error = this.querySelector('.wp-buy-now__error');
          this.button.addEventListener('click', () => this.buy());
          this.watchAddToCart();
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        get form() {
          const scope = this.closest('.shopify-section') || document;
          return scope.querySelector('form[data-type="add-to-cart-form"]');
        }

        // Keep this button in step with add to cart (sold out, unavailable variant)
        watchAddToCart() {
          const addButton = this.form?.querySelector('button[type="submit"], [name="add"]');
          if (!addButton) return;
          const sync = () => (this.button.disabled = addButton.disabled);
          sync();
          this.observer = new MutationObserver(sync);
          this.observer.observe(addButton, { attributes: true, attributeFilter: ['disabled'] });
        }

        async buy() {
          const form = this.form;
          const id = form?.querySelector('input[name="id"]')?.value;
          if (!id) return;
          const quantity = Number(form.querySelector('input[name="quantity"]')?.value) || 1;

          this.classList.add('is-loading');
          this.button.disabled = true;
          this.error.hidden = true;
          try {
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(id), quantity }] }),
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.description || data.message || 'Could not add this item.');
            window.location.href = this.button.dataset.checkoutUrl;
          } catch (err) {
            this.error.textContent = err.message;
            this.error.hidden = false;
            this.classList.remove('is-loading');
            this.button.disabled = false;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('brand-delivery-estimate')) {
    customElements.define(
      'brand-delivery-estimate',
      class extends HTMLElement {
        connectedCallback() {
          const off = (this.dataset.off || '').split(',').filter(Boolean).map(Number);
          const addBusinessDays = (days) => {
            const date = new Date();
            let added = 0;
            while (added < days) {
              date.setDate(date.getDate() + 1);
              if (!off.includes(date.getDay())) added++;
            }
            return date;
          };
          let fmt;
          try {
            fmt = new Intl.DateTimeFormat(this.dataset.locale, { weekday: 'short', day: 'numeric', month: 'short' });
          } catch (e) {
            fmt = new Intl.DateTimeFormat(undefined, { weekday: 'short', day: 'numeric', month: 'short' });
          }
          const from = fmt.format(addBusinessDays(Number(this.dataset.min)));
          const to = fmt.format(addBusinessDays(Number(this.dataset.max)));
          const text = this.querySelector('[data-text]');
          text.innerHTML = this.querySelector('[data-template]').innerHTML.replace('__FROM__', from).replace('__TO__', to);
          text.hidden = false;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["fit-finder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('brand-fit-finder')) {
    // Accept Arabic-Indic digits typed on an Arabic keyboard
    const toNumber = (v) =>
      Number(String(v || '').replace(/[٠-٩]/g, (c) => c.charCodeAt(0) - 0x0660).replace(/[^\d.]/g, ''));
    const range = (text) => {
      const [min, max] = String(text).split(/[-–]/).map(toNumber);
      return { min, max: max || min };
    };
    const within = (value, r) => value >= r.min && value <= r.max;

    class BrandFitFinder extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.strings = JSON.parse(this.querySelector('script[data-strings]').textContent);
        this.rows = [...this.querySelectorAll('[data-row]')].map((tr) => ({
          size: tr.dataset.size,
          height: range(tr.dataset.height),
          weight: range(tr.dataset.weight),
          el: tr,
        }));
        this.querySelector('[data-open]').addEventListener('click', () => this.open());
        this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (e) => {
          if (e.target === this.dialog) this.dialog.close();
        });
        this.tabs = [...this.querySelectorAll('[data-tab]')];
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.selectTab(i));
          tab.addEventListener('keydown', (e) => {
            const dir = document.documentElement.dir === 'rtl' ? -1 : 1;
            const n = this.tabs.length;
            if (e.key === 'ArrowRight') this.selectTab((i + dir + n) % n, true);
            if (e.key === 'ArrowLeft') this.selectTab((i - dir + n) % n, true);
          });
        });
        this.querySelector('[data-form]').addEventListener('submit', (e) => {
          e.preventDefault();
          this.recommend();
        });
        this.querySelector('[data-select]').addEventListener('click', () => this.applySize());
      }

      open() {
        this.dialog.showModal();
        this.querySelector('input[name="height"]')?.focus();
      }

      selectTab(index, focus = false) {
        this.tabs.forEach((tab, i) => {
          const active = i === index;
          tab.setAttribute('aria-selected', active);
          tab.tabIndex = active ? 0 : -1;
          this.querySelector('#' + tab.getAttribute('aria-controls')).hidden = !active;
        });
        if (focus) this.tabs[index].focus();
      }

      fill(template, x, y = '') {
        return template.replace('__X__', x).replace('__Y__', y);
      }

      pick(height, weight) {
        const rows = this.rows;
        const byWeight = rows.filter((r) => within(weight, r.weight));
        if (!byWeight.length) {
          // Off the chart: point to the nearest end, but flag it
          const row = weight < rows[0].weight.min ? rows[0] : rows[rows.length - 1];
          return { row, notes: [this.strings.out], warn: true };
        }
        const both = byWeight.filter((r) => within(height, r.height));
        if (both.length > 1) {
          // Shared boundary weight (e.g. 55 kg): go one size up for comfort
          const row = both[both.length - 1];
          return { row, notes: [this.fill(this.strings.between, row.size, both[0].size)], warn: false };
        }
        if (both.length === 1) return { row: both[0], notes: [this.strings.perfect], warn: false };

        // Weight fits but height doesn't: keep the weight size, explain the length
        const row = byWeight[byWeight.length - 1];
        const note = height < row.height.min ? this.strings.longer : this.strings.shorter;
        const offChart = height < rows[0].height.min || height > rows[rows.length - 1].height.max;
        return { row, notes: offChart ? [note, this.strings.out] : [note], warn: offChart };
      }

      recommend() {
        const form = this.querySelector('[data-form]');
        const height = toNumber(form.height.value);
        const weight = toNumber(form.weight.value);
        const error = this.querySelector('[data-error]');
        if (!this.rows.length || height < 120 || height > 220 || weight < 30 || weight > 200) {
          error.hidden = false;
          (height < 120 || height > 220 ? form.height : form.weight).focus();
          return;
        }
        error.hidden = true;

        const { row, notes, warn } = this.pick(height, weight);
        this.chosen = row.size;
        this.rows.forEach((r) => r.el.classList.toggle('is-match', r === row));

        this.querySelector('[data-result-size]').textContent = this.fill(this.strings.size, row.size);
        this.querySelector('[data-result-note]').textContent = notes.join(' ');
        const select = this.querySelector('[data-select]');
        select.hidden = !this.findInput(row.size);
        select.disabled = false;
        select.textContent = this.fill(this.strings.select, row.size);
        const wa = this.querySelector('[data-wa]');
        if (wa) wa.hidden = !warn;
        const result = this.querySelector('[data-result]');
        result.hidden = false;
        result.classList.toggle('is-warning', warn);
      }

      findInput(size) {
        const scope = this.closest('.shopify-section') || document;
        const option = this.dataset.sizeOption;
        return [...scope.querySelectorAll('variant-picker input[type="radio"], .variant-picker input[type="radio"]')].find(
          (el) => el.value === size && (!option || el.name.startsWith(option))
        );
      }

      applySize() {
        const input = this.findInput(this.chosen);
        if (input && !input.checked) input.click();
        const select = this.querySelector('[data-select]');
        select.textContent = this.strings.selected + ' ✓';
        select.disabled = true;
        setTimeout(() => this.dialog.close(), 700);
      }
    }
    customElements.define('brand-fit-finder', BrandFitFinder);
  }
  } catch(e) { console.error(e); }
})();

})();
